// src/pages/Privacy.js

import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#121212',
      paper: '#121212',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0b0b0',
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
    h4: {
      fontWeight: 500,
    },
    body1: {
      lineHeight: 1.8,
    },
  },
components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: '2rem',
          borderRadius: '12px',
          backgroundColor: '#121212', // Ensure Paper uses slightly lighter black
        },
      },
    },
  },
});

const Privacy = () => {
  return (
    <ThemeProvider theme={darkTheme}>
      <Container maxWidth="md" style={{ marginTop: '3rem' }}>
        <Paper elevation={3}>
          <Box mb={4}>
            <Typography variant="h4" gutterBottom>
              Privacy Policy
            </Typography>
            <Typography variant="body1" color="textSecondary">
              Last updated: August 2024
            </Typography>
          </Box>

          <Box mb={4}>
            <Typography variant="h6" gutterBottom>
              Information We Collect
            </Typography>
            <Typography variant="body1">
              We collect personal information that you provide to us directly, such as your name, email address, and phone number, when you use our services or contact us.
            </Typography>
          </Box>

          <Box mb={4}>
            <Typography variant="h6" gutterBottom>
              How We Use Your Information
            </Typography>
            <Typography variant="body1">
              The information we collect is used to provide, maintain, and improve our services. We may also use your information to communicate with you about updates, offers, or other matters related to our services.
            </Typography>
          </Box>

          <Box mb={4}>
            <Typography variant="h6" gutterBottom>
              Sharing of Information
            </Typography>
            <Typography variant="body1">
              We do not share your personal information with third parties, except as necessary to provide our services or comply with legal obligations.
            </Typography>
          </Box>

          <Box mb={4}>
            <Typography variant="h6" gutterBottom>
              Data Security
            </Typography>
            <Typography variant="body1">
              We take the security of your data seriously and implement measures to protect it. However, no system is completely secure, and you use our services at your own risk.
            </Typography>
          </Box>

          <Box mb={4}>
            <Typography variant="h6" gutterBottom>
              Changes to This Policy
            </Typography>
            <Typography variant="body1">
              We may update our privacy policy from time to time. Please review this page periodically for the latest information on our practices.
            </Typography>
          </Box>

          <Box mt={6}>
            <Typography variant="body2" color="textSecondary">
              Contact us at harrypeng55@gmail.com
            </Typography>
          </Box>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default Privacy;
